module.exports = __webpack_public_path__ + "static/media/arrow-icon.2c4de12c.svg";